<template>
    <div>
        <b-row>
            <b-col>
                <h2>Diário</h2>
            </b-col>
            <b-col class="text-right">
                <b-button variant="primary" size="sm" @click="goDespesas()"><i class="fas fa-dollar-sign"></i> Mostrar
                    Despesas</b-button>
                <b-button variant="primary" size="sm" @click="goRotas()"><i class="fa fa-map"></i> Voltar</b-button>
            </b-col>
        </b-row>

        <b-card>
            <b-card-body>
                <b-card class="mb-2">
                    <b-card-header>
                        <b-row align-h="center" align-v="end">
                            <b-col>
                                <b-calendar :disabled="loading" class="border mt-2" block label-help=""
                                    hide-header nav-button-variant="primary" today-variant="danger" v-model="calendario"
                                    @selected="onContext">
                                </b-calendar>
                            </b-col>
                            <b-col>
                                <b-card>
                                    <b-row>
                                        <b-col>
                                            <span v-if="calendario"> Data Selecionada: <b> {{ dataSelecionadaFormatada }}
                                                </b></span>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <label for="">Usuário</label>
                                            <b-form-select size="sm" v-model="filtro.usuario" :options="listUsuarios"
                                                @change="onContext()"></b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <label for="">Motivo</label>
                                            <b-form-select size="sm" v-model="filtro.motivo" :options="optionsMotivo"
                                                @change="onContext()"></b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <label for="">Status</label>
                                            <b-form-select size="sm" v-model="filtro.status" :options="optionsStatus"
                                                @change="onContext()"></b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <b-button variant="primary" size="sm" title="Buscar" @click="onContext()"><i
                                                    class="fas fa-search"></i>Buscar</b-button>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-card-body>
                        <b-row align-v="end">
                            <b-col md="3">
                                <b-form-select class="md-2 col-md-2" id="per-page-select" v-model="perPage"
                                    :options="pageOptions" size="sm" @change="getRoteiros()">
                                </b-form-select>
                            </b-col>
                            <b-col class="text-center" md="6"> Total de Visitas: {{ total_row }} </b-col>
                            <b-col align-h="end" md="3">
                                <b-pagination size="sm" fill v-if="total_row > 4" :disabled="loading" v-model="currentPage"
                                    :total-rows="total_row" :per-page="perPage" @input="getRoteiros()"></b-pagination>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <b-table :busy="loading" :items="roteiros" :fields="fields" small hover striped>
                                    <template #table-busy>
                                        <div class="text-center text-primary my-2">
                                            <b-spinner small class="align-middle"></b-spinner>
                                            <strong>Carregando...</strong>
                                        </div>
                                    </template>
                                    <template #cell(actions)="row">
                                        <b-button v-if="row.item.status == 'ABERTO'" variant="success" size="sm"
                                            title="Aprovar" @click="aprovar(row.item)"><i
                                                class="fas fa-thumbs-up"></i></b-button>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-card-body>
        </b-card>

        <!--------------------------Modal para adicionar visita------------------------->
        <b-modal v-model="modalVisita" size="lg">
            <b-card>
                <b-card-body>
                    <b-row>
                        <b-col>
                            <label for="">Consultor</label>
                            <b-form-select v-model="visita.consultor" :options="listUsuarios"></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <label for="">Motivo</label>
                            <b-form-select v-model="visita.motivo" :options="optionsMotivo"></b-form-select>
                        </b-col>
                        <!--  <b-col>
                            <label for="">Data da Visita</label>
                            <date-picker v-model="visita.data" :config="datePickerConfig" placeholder="Data da Visita"></date-picker>
                        </b-col> -->
                        <!-- <b-col>
                            <label for="example-datepicker">Data da Visita</label>
                            <b-form-datepicker hide-header v-model="visita.data" class="mb-2"></b-form-datepicker>
                        </b-col> -->
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <label for="">Nome do(a) Cliente</label>
                            <b-form-input v-model="visita.cliente" placeholder="Digite o nome"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col>
                            <label for="">Obs</label>
                            <b-form-textarea id="textarea" v-model="visita.obs" placeholder="Observações" rows="3"
                                max-rows="6"></b-form-textarea>
                        </b-col>
                    </b-row>

                </b-card-body>
            </b-card>
            <template #modal-header>
                <h4>Adicionar visita em: {{ dataSelecionadaFormatada }}</h4>
            </template>
            <template #modal-footer>
                <b-button variant="primary" size="sm" @click="saveVisita()"><i class="fas fa-save"></i> Salvar</b-button>
                <b-button variant="danger" size="sm" @click="modalVisita = false">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment, { relativeTimeThreshold } from 'moment';
import DatePicker from "vue-bootstrap-datetimepicker/src/component";


export default {
    data() {
        return {
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true
            },
            filtro: {
                usuario: null,
                motivo: 'TODOS',
                status: 'TODOS',
            },
            visita: {
                consultor: null,
                motivo: null,
                data: '',
                cliente: '',
                obs: '',
            },
            calendario: moment().format("YYYY-MM-DD"),
            context: null,
            dataSelecionada: moment().format("YYYY-MM-DD"),
            dataSelecionadaFormatada: moment().format("DD/MM/YYYY"),
            currentPage: 1,
            total_row: 0,
            perPage: 10,
            pageOptions: [5, 10, 20, 30, 50],
            loading: false,
            roteiros: [],
            fields: [
                { key: 'actions', label: '' },
                { key: 'usuario.name', label: 'Consultor' },
                { key: 'motivo', label: 'Motivo' },
                {
                    key: 'data_vizita',
                    label: 'Data da Visita',
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    },
                },
                { key: 'nome', label: 'Cliente' },
                { key: 'status', label: 'Status' },
            ],
            modalVisita: false,
            optionsMotivo: ['TODOS', 'PROSPECTO', 'NEGOCIACAO', 'RECUPERACAO', 'OUTROS'],
            optionsStatus: ['TODOS', 'ABERTO', 'FINALIZADO'],
            listUsuarios: []
        };
    },
    methods: {
        saveVisita() {

        },
        adicionarVisita() {
            this.visita = {
                consultor: null,
                motivo: null,
                data: '',
                cliente: '',
                obs: '',
            }
            this.modalVisita = true;
        },
        aprovar(event) {
            var vm = this;
            console.log(event)
            if (event.status) {
                vm.$swal({
                    title: event.usuario.name,
                    html:
                        '<li>Cliente: ' + event.nome + '</li>' +
                        '<li>Data da Visita: ' + moment(event.data_vizita).format('DD/MM/YYYY') + '</li>' +
                        '<li>Motivo: ' + event.motivo + '</li> <br>' +
                        '<h4>Deseja realmente finalizar esta visita?<h4>',
                    icon: 'question',
                    width: 600,
                    padding: '3em',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, Finalizar!',
                    confirmButtonColor: '#008000',
                    cancelButtonText: 'Não!',
                    cancelButtonColor: '#8B0000',
                    showCloseButton: true,
                }).then((result) => {
                    if (result.value) {
                        vm.$swal.fire({
                            title: 'Relate como foi a visita?',
                            input: 'textarea',
                            inputAttributes: {
                                autocapitalize: 'off'
                            },
                            width: 600,
                            padding: '3em',
                            showCancelButton: true,
                            cancelButtonText: 'Cancelar',
                            cancelButtonColor: '#8B0000',
                            confirmButtonText: event.status === 'ABERTO' ? 'Finalizar' : 'Atualizar',
                            showLoaderOnConfirm: true,
                            preConfirm: (data) => {
                                console.log(data);
                                return axios.post('/adm/rotas/finaliza/subrota/' + event.id, { justifica: data })
                                    .then(response => {
                                        /*if (!response.data) {
                                            console.log(response);
                                            throw new Error(response);
                                        } */
                                        vm.getRoteiros();
                                        return response.data.success;
                                    })
                                    .catch(error => {
                                        vm.$swal.showValidationMessage(
                                            error.response.data.errors
                                        )
                                    })
                            },
                            allowOutsideClick: () => !vm.$swal.isLoading()
                        }).then((result) => {
                            if (result.value) {
                                // this.events();
                                vm.$swal.fire({
                                    title: value,
                                })
                            }
                        })
                    }
                });
            } else {
                alert('Periodo da Rota ...' + event.rota);
            }
        },
        onContext(ctx) {
            //console.log(ctx)
            this.currentPage = 1
            this.dataSelecionada = this.calendario ? moment(this.calendario).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            this.dataSelecionadaFormatada = moment(this.dataSelecionada).format('DD/MM/YYYY');
            this.getRoteiros()
        },
        getRoteiros() {
            const vm = this;
            vm.loading = true;
            this.roteiros = [];
            const data = {
                perPage: this.perPage,
                currentPage: this.currentPage,
                show: true,
                data: this.dataSelecionada,
                filtros: this.filtro
            }
            axios.get('/adm/rotas/diario', { params: data }).then((response) => {
                //console.log(response)
                this.roteiros = response.data.data
                this.total_row = response.data.total
            }).catch((erro) => {
                console.log(erro);
            }).finally(() => {
                vm.loading = false
            })
        },
        loadUsers() {
            const vm = this;
            axios.get('/user/perfil/gestor').then((response) => {
                vm.listUsuarios = [{ value: null, text: 'TODOS' }];
                response.data.map((el) => {
                    vm.listUsuarios.push({ value: el.id, text: el.name.toUpperCase() });
                })
            }).catch((erro) => {
                console.log(erro);
            })
        },
        goDespesas() {
            window.location.href = "/adm/despesas"
        },
        goRotas() {
            window.location.href = "/adm/rotas";
        },
    },
    mounted() {
        this.loadUsers();
        this.getRoteiros();
    }
};
</script>

<style></style>


// WEBPACK FOOTER //
// resources/assets/js/components/rotas/Diario.vue